import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import DefaultInput from "../../inputs/defaultInput";
import Loading from "../../skeleton/loading";
import DefaultTextarea from "../../inputs/defaultTextarea";
import DefaultButton from "../../buttons/defaultButton";
import {
  createDepartment,
  getDepartmentDetail,
  updateDepartment,
} from "../../../../services/workspace/department.service";
import { _updateDepartment } from "../../../../store/slices/baseSetup.slice";
import { _fetchDepartments } from "../../../../store/actions/configuration";
import { useDispatch, useSelector } from "react-redux";
import DefaultSearchSelectInput from "../../inputs/defaultSearchSelectInput";
import DragAndDropFile from "../../inputs/simpleFileUploader";
import {
  createVendor,
  getCategoryList,
  updateVendor,
} from "../../../../services/workspace/inventory.service";
import { convertToLabelValue } from "../../../../utils/common";
import { _retrieveVendorDetails } from "../../../../store/actions/vendor";

const validationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  // abrv: Yup.string().trim().required("Abbreviation is required"),
  // tags: Yup.string().trim().required("tags are required"),
  // category: Yup.object().required("Sub Category is required"),
  category: Yup.array()
    .of(Yup.object().required("Category is required"))
    .required("Category are required")
    .min(1, "At least one Category must be selected"),
  contact: Yup.number().required("Number is required"),
  // alternate_contact: Yup.string()
  //   .trim()
  //   .required("Alternate Number is required"),
  // email: Yup.string().trim().required("Email is required"),
  // website: Yup.string().required("Website is required"),
  // address: Yup.string().trim().required("Address is required"),
});

const AddVendorForm = ({ isModal = false, category, closeModal = () => null }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  // const [category, setCategory] = useState();
  const { vendorDetail } = useSelector((state) => state.vendor);

  useEffect(() => {
    if (!isModal) {
      if (id) dispatch(_retrieveVendorDetails(id));
    }
  }, [id]);

  useEffect(() => {
    setData(vendorDetail); 
  }, [vendorDetail]);

 

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      name: data?.name || "",
      abrv: data?.abrv || "",
      tags: data?.tags || "",
      category: data?.category || "",
      contact: data?.contact || "",
      alternate_contact: data?.alternate_contact || "",
      email: data?.email || "",
      website: data?.website || "",
      address: data?.address || "",

    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setIsSubmitting(true);

      const newCat = values?.category.map((cat) => {
        return cat.id;
      });

      // const payload = {
      //   name: values?.name || "",
      //   abrv: values?.abrv || "",
      //   tags: values?.tags || "",
      //   category: values?.category || "",
      //   contact: values?.contact || "",
      //   alternate_contact: values?.alternate_contact || "",
      //   email: values?.email || "",
      //   website: values?.website || "",
      //   address: values?.address || "",
      // };

      if (id && !isModal) {
        updateVendor({ ...values, categories: newCat }, id)
          .then(() => {
            toast.success("Vendor updated successfully!");
            navigate("/inventory/vendor");
          })
          .catch((error) => {
            setIsSubmitting(false);
            toast.error(
              "Failed to update Vendor! " + error.response.data?.message
            );
          });
      } else {
        createVendor({ ...values, categories: newCat })
          .then((response) => {
            toast.success("Vendor created successfully!");
            if (isModal) {
              closeModal();
            } else {
              navigate("/inventory/vendor");
            }
          })
          .catch((error) => {
            setIsSubmitting(false);
            toast.error("Failed to create! " + error.response.data?.message);
          });
      }
    },
  });

  useEffect(() => {
    setLoading(true);

    getCategoryList()
      .then((response) => {
        setLoading(false);
        // setCategory(convertToLabelValue(response.data));

        // setData(response);
      })
      .catch((error) => {
        toast.error("Failed to fetch the department data!");
      });
  }, []);

  return (
    <Fragment>
      {loading ? (
        <Loading />
      ) : (
        <div className="flex flex-col w-full gap-4 bg-white rounded-md p-4">
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="gap-6 flex flex-col">
              <div className="flex flex-col gap-2">
                <h1 className="font-bold text-cs text-theme">
                  General Information
                </h1>
                <div className="grid grid-cols-4 gap-4 gap-y-2">
                  <DefaultInput
                    label="Vendor Name"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.name && errors.name}
                    required
                  />
                  <DefaultInput
                    label="Abbreviation"
                    name="abrv"
                    value={values.abrv}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <DefaultInput
                    label="Tags"
                    name="tags"
                    value={values.tags}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <DefaultSearchSelectInput
                    label={"Categories"}
                    name="category"
                    options={category}
                    onChange={(e) => {
                      setFieldValue("category", e);
                    }}
                    value={values.category}
                    error={
                      touched.category && errors.category ? errors.category : ""
                    }
                    required
                    isMulti={true}
                  />
                  {/* <DefaultSearchSelectInput
                    label="Category"
                    name="category"
                    options={category}
                    onChange={(e) => {
                      setFieldValue("category", e);
                    }}
                    value={values.category}
                    onBlur={handleBlur}
                    error={touched.category && errors.category}
                    required
                  /> */}
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <h1 className="font-bold text-cs text-theme">
                  Contact Information
                </h1>
                <div className="grid grid-cols-4 gap-4 gap-y-2">
                  <DefaultInput
                    label="Contact Number"
                    name="contact"
                    type={"number"}
                    value={values.contact}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.contact && errors.contact}
                    required
                  />
                  <DefaultInput
                    label="Alternate Number"
                    name="alternate_contact"
                    value={values.alternate_contact}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <DefaultInput
                    label="Email Address"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <DefaultInput
                    label="Website"
                    name="website"
                    value={values.website}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <h1 className="font-bold text-cs text-theme">Address</h1>
                <div className="grid grid-cols-1 gap-4 gap-y-2">
                  <DefaultInput
                    label="Address"
                    name="address"
                    value={values.address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <DefaultButton
                variant="default"
                name="Add"
                type="submit"
                loading={isSubmitting}
              />
              <DefaultButton
                variant="secondary"
                name="Cancel"
                onClick={closeModal}
              />
            </div>
          </form>
        </div>
      )}
    </Fragment>
  );
};

export default AddVendorForm;
